(function ($, window, undefined) {

        (function () {
            'use strict';

            $('.tablet-mock').waypoint(function () {

                var self = this.element;
                $(self).addClass('active');
            }, {
                offset: '90%'
            });

            $('#vincule-processos #phone').waypoint(function () {

                var self = this.element;
                $(self).addClass('active');
            }, {
                offset: '100%'
            });


        }());

    }(jQuery, window));